import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import jwt_decode from 'jwt-decode';

type TokenInfo = {
  applicationId: string;
  refereeId: string;
  formId: string;
  userInfo: {
    formId: string;
    applicationId: string;
    refereeId: string;
    academicRefereeId: string;
  };
};

export const useGetAcademicRefereeToken = (
  token: string,
): {
  data?: TokenInfo;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { data, loading, error } = useQuery(
    gql`
      query ($token: String!) {
        getRefereeFormToken(token: $token)
      }
    `,
    {
      variables: { token },
    },
  );

  return {
    data: (data?.getRefereeFormToken as boolean)
      ? jwt_decode(data?.getRefereeFormToken)
      : undefined,
    loading,
    error,
  };
};
